import { useTheme } from '~/hooks/use-theme'

export const TOOLTIP_CONSTANTS = {
  LAYOUT_RECALCULATION_DELAY: 100,
  LAYOUT_TOLERANCE: 1,
  MAX_LINES: 4,
  LATERAL_WIDTH_OFFSET: 24,
  VERTICAL_ALIGNMENT_DIVISOR: 5,
} as const

export const useTooltipConstants = () => {
  const theme = useTheme()

  return {
    SCREEN_PADDING: theme.spacingStackTwopulse,
    SCREEN_MARGIN: theme.spacingStackFourpulse,
    CONTENT_GAP: theme.spacingStackTwopulse,
    ARROW_SIZE: theme.sizingMicro,
    LAYOUT_RECALCULATION_DELAY: TOOLTIP_CONSTANTS.LAYOUT_RECALCULATION_DELAY,
    LAYOUT_TOLERANCE: TOOLTIP_CONSTANTS.LAYOUT_TOLERANCE,
    MAX_LINES: TOOLTIP_CONSTANTS.MAX_LINES,
    LATERAL_WIDTH_OFFSET: TOOLTIP_CONSTANTS.LATERAL_WIDTH_OFFSET,
    FIXED_LATERAL_WIDTH:
      theme.sizingHuge - TOOLTIP_CONSTANTS.LATERAL_WIDTH_OFFSET,
    VERTICAL_ALIGNMENT_DIVISOR: TOOLTIP_CONSTANTS.VERTICAL_ALIGNMENT_DIVISOR,
  }
}
